export type Event =
    | BookingPageInitiated
    | BookingPageInteraction
    | BookingRyanairVerification
    | BookingRyanairInteraction
    | BookingRyanairBookingExpired
    | BookingHotelWidgetAddon
    | BookingTripWidgetAddon
    | BookingRentalCarWidgetAddon
    | BookingAccommodationAddon
    | BookingBaggageAddon
    | BookingRentalCarAddon
    | BookingTransferAddon
    | BookingSeatingAddon
    | BookingFerryAddon
    | BookingFerryExtraAddon
    | BookingServicePackageAddon
    | BookingTravelInsuranceAddon
    | BookingAddonOpen
    | BookingUpsellInteraction
    | BookingUpsellAvailable
    | BookingSpotlights
    | BookingSpotlightsRearranged
    | BookingHotelWidgetInteraction
    | BookingHotelWidgetAvailable
    | BookingHotelWidgetEmptyResult
    | BookingTripWidgetAvailable
    | BookingCancellationTermsClick
    | BookingTransferConditionsClick
    | BookingTransferVoucherClick
    | BookingCancelClick
    | BookingConfirmationClick
    | BookingVoucherClick
    | BookingPayClick
    | BookingFooterNewsletterClick
    | BookingFooterFaqClick
    | BookingOpenSectionJourneyDetails
    | BookingOpenSectionPassengersDetails
    | BookingOpenSupplierNotes
    | BookingServicePackageRequestOpen
    | BookingServicePackageRequestSent
    | BookingServicePackageAvailable
    | BookingServicePackageInteraction
    | BookingServicePackageOpen
    | BookingServicePackageClose
    | BookingCustomerServiceMessagesOpen
    | BookingPackageRulesPrompted
    | BookingPackageRulesContinued
    | BookingImportantInformationOpen
    | BookingCouponVisible
    | BookingCouponOpen
    | BookingCouponClose
    | BookingCouponCodeCopied
    | BookingAddRemoveAddon
    | BookingsPageInitiated
    | BookingsPageInteraction
    | BookingPaymentModal
    | BookingPaymentModalInteraction
    | BookingPaymentRedirect
    | BookingBrandedFareSelected
    | CheckoutPageInitiatedEvent
    | CheckoutRyanairInteractionEvent
    | CheckoutCartSessionStoreEvent
    | CheckoutCartSessionUpdateEvent
    | CheckoutUserDetailsInitiatedEvent
    | CheckoutUserDetailsCompletedEvent
    | CheckoutUserOptOutNewsletterEvent
    | CheckoutAddAddonEvent
    | CheckoutRemoveAddonEvent
    | CheckoutAddBaggageEvent
    | CheckoutRemoveBaggageEvent
    | CheckoutAddSeatingEvent
    | CheckoutRemoveSeatingEvent
    | CheckoutRemoveProductEvent
    | CheckoutShowHotelInfo
    | CheckoutShowRoomInfo
    | CheckoutMoreInformationOpen
    | CheckoutPriceDetailsOpen
    | CheckoutTransferBanner
    | CheckoutTransferBannerOpen
    | CheckoutTransferAdded
    | CheckoutTransferInteraction
    | CheckoutTransferAvailableTrips
    | CheckoutTransferAvailableOptions
    | CheckoutTicketPolicyOpen
    | CheckoutCancellationPanelOpen
    | CheckoutCancellationTermsOpen
    | CheckoutPriceBreakdownBadgeOpen
    | CheckoutPriceBreakdownDetailsOpen
    | CheckoutPriceBreakdownFooterOpen
    | CheckoutPriceGuaranteeOpen
    | CheckoutChangeTraveller
    | CheckoutChangeTravellerOpen
    | CheckoutSubmitInvalidState
    | CheckoutImportantNotesOpen
    | CheckoutEditSection
    | CheckoutOpenSection
    | CheckoutCompleteSection
    | CheckoutInvalidInput
    | CheckoutOpenSectionDetails
    | CheckoutOpenSectionImage
    | CheckoutOpenSectionOverviewDetails
    | CheckoutOpenSectionJourneyDetails
    | CheckoutTripSummary
    | CheckoutTripSummaryExpand
    | CheckoutDiscountCodeOpen
    | CheckoutDiscountCodeApplied
    | CheckoutDiscountCodeError
    | CheckoutCopyFeatureClick
    | CheckoutCopyFeatureInvalidForm
    | CheckoutCopyFeatureApplied
    | CheckoutSembonusAvailable
    | CheckoutSembonusApplied
    | CheckoutSembonusView
    | CheckoutSembonusInteraction
    | CheckoutBaggageWarningOpen
    | CheckoutBaggageWarningInteraction
    | CheckoutServicePackageWarningOpen
    | CheckoutServicePackageWarningInteraction
    | CheckoutAppliedDiscountInteraction
    | CheckoutServicePackageInteraction
    | CheckoutBrandedFareSelected
    | PaymentPageInitiatedEvent
    | PaymentTypeSelectEvent
    | PaymentMethodSelectEvent
    | PaymentCancellationTermsClick
    | PaymentGiftCardRequiresCvcEvent
    | PaymentMethodCompletedEvent
    | PaymentFailedError
    | PaymentPageMessage
    | PaymentBookingRedirect
    | PaymentLeabankFormOpen
    | PaymentLeabankSubmitApplication
    | PaymentBookNowPayLaterAvailable
    | PaymentBookNowPayLaterInteraction
    | PreCheckoutPageInitiated
    | PreCheckoutPageCompleted
    | PreCheckoutPageRedirected
    | PreCheckoutBrandedFareAvailable
    | PreCheckoutBrandedFareOptionAvailable
    | PostCheckoutPageInitiated
    | PostCheckoutPageCompleted
    | SkipPostCheckoutPage
    | MetaFlightPageInitiated
    | GeneralError
    | CustomError
    | PerformanceAPI
    | SeatingAvailabilityStatus
    | CheckoutDuplicatePaxWarningOpen
    | TranslationMissingKey
    | AmeliaAvailable
    | AmeliaInteraction
    | AmeliaFeedbackMessage;

export enum StatsigEvent {
    BOOKING_ACCOMMODATION_ADDON = 'booking_accommodation_addon',
    BOOKING_HOTEL_WIDGET_ADDON = 'booking_hotel_widget_addon',
    BOOKING_TRIP_WIDGET_ADDON = 'booking_trip_widget_addon',
    BOOKING_RENTALCAR_WIDGET_ADDON = 'booking_rentalcar_widget_addon',
    BOOKING_BAGGAGE_ADDON = 'booking_baggage_addon',
    BOOKING_RENTALCAR_ADDON = 'booking_rentalcar_addon',
    BOOKING_TRANSFER_ADDON = 'booking_transfer_addon',
    BOOKING_SERVICEPACKAGE_ADDON = 'booking_servicepackage_addon',
    BOOKING_TRAVELINSURANCE_ADDON = 'booking_travelinsurance_addon',
    BOOKING_SEATING_ADDON = 'booking_seating_addon',
    BOOKING_FERRY_ADDON = 'booking_ferry_addon',
    BOOKING_FERRY_EXTRA_ADDON = 'booking_ferry_extra_addon',
    BOOKING_ADDON_OPEN = 'booking_addon_open',
    BOOKING_PAGE_INITIATED = 'booking_page_initiated',
    BOOKING_PAGE_INTERACTION = 'booking_page_interaction',
    BOOKING_RYANAIR_VERIFICATION = 'booking_ryanair_verification',
    BOOKING_RYANAIR_INTERACTION = 'booking_ryanair_interaction',
    BOOKING_RYANAIR_BOOKING_EXPIRED = 'booking_ryanair_booking_expired',
    BOOKING_UPSELL_INTERACTION = 'booking_upsell_interaction',
    BOOKING_UPSELL_AVAILABLE = 'booking_upsell_available',
    BOOKING_SERVICE_PACKAGE_AVAILABLE = 'booking_service_package_available',
    BOOKING_SERVICE_PACKAGE_INTERACTION = 'booking_service_package_interaction',
    BOOKING_SERVICE_PACKAGE_OPEN = 'booking_service_package_open',
    BOOKING_SERVICE_PACKAGE_CLOSE = 'booking_service_package_close',
    BOOKING_SPOTLIGHTS = 'booking_spotlights',
    BOOKING_SPOTLIGHTS_REARRANGED = 'booking_spotlights_rearranged',
    BOOKING_HOTEL_WIDGET_INTERACTION = 'booking_hotel_widget_interaction',
    BOOKING_HOTEL_WIDGET_AVAILABLE = 'booking_hotel_widget_available',
    BOOKING_HOTEL_WIDGET_EMPTY_RESULT = 'booking_hotel_widget_empty_result',
    BOOKING_TRIP_WIDGET_AVAILABLE = 'booking_trip_widget_available',
    BOOKING_CANCELLATION_TERMS_CLICK = 'booking_cancellation_terms_click',
    BOOKING_TRANSFER_CONDITIONS_CLICK = 'booking_transfer_conditions_click',
    BOOKING_TRANSFER_VOUCHER_CLICK = 'booking_transfer_voucher_click',
    BOOKING_CANCEL_CLICK = 'booking_cancel_click',
    BOOKING_CONFIRMATION_CLICK = 'booking_confirmation_click',
    BOOKING_VOUCHER_CLICK = 'booking_voucher_click',
    BOOKING_PAY_CLICK = 'booking_pay_click',
    BOOKING_FOOTER_NEWSLETTER_CLICK = 'booking_footer_newsletter_click',
    BOOKING_FOOTER_FAQ_CLICK = 'booking_footer_faq_click',
    BOOKING_OPEN_SECTION_JOURNEY_DETAILS = 'booking_open_section_journey_details',
    BOOKING_OPEN_SECTION_PASSENGERS_DETAILS = 'booking_open_section_passengers_details',
    BOOKING_OPEN_SUPPLIER_NOTES = 'booking_open_supplier_notes',
    BOOKING_SERVICE_PACKAGE_REQUEST_OPEN = 'booking_service_package_request_open',
    BOOKING_SERVICE_PACKAGE_REQUEST_SENT = 'booking_service_package_request_sent',
    BOOKING_CUSTOMER_SERVICE_MESSAGES_OPEN = 'booking_customer_service_messages_open',
    BOOKING_PACKAGE_RULES_PROMPTED = 'booking_package_rules_prompted',
    BOOKING_PACKAGE_RULES_CONTINUED = 'booking_package_rules_continued',
    BOOKING_IMPORTANT_INFORMATION_OPEN = 'booking_important_information_open',
    BOOKING_COUPON_VISIBLE = 'booking_coupon_visible',
    BOOKING_COUPON_OPEN = 'booking_coupon_open',
    BOOKING_COUPON_CLOSE = 'booking_coupon_close',
    BOOKING_COUPON_CODE_COPIED = 'booking_coupon_code_copied',
    BOOKING_ADD_ADDON = 'booking_add_addon',
    BOOKING_REMOVE_ADDON = 'booking_remove_addon',
    BOOKINGS_PAGE_INITIATED = 'bookings_page_initiated',
    BOOKINGS_PAGE_INTERACTION = 'bookings_page_interaction',
    BOOKING_PAYMENT_MODAL = 'booking_payment_modal',
    BOOKING_PAYMENT_MODAL_INTERACTION = 'booking_payment_modal_interaction',
    BOOKING_PAYMENT_REDIRECT = 'booking_payment_redirect',
    BOOKING_BRANDED_FARE_SELECTED = 'booking_branded_fare_selected',
    CHECKOUT_PAGE_INITIATED = 'checkout_page_initiated',
    CHECKOUT_RYANAIR_INTERACTION = 'checkout_ryanair_interaction',
    CHECKOUT_CART_SESSION_STORE = 'checkout_cart_session_store',
    CHECKOUT_CART_SESSION_UPDATE = 'checkout_cart_session_update',
    CHECKOUT_USER_DETAILS_INITIATED = 'checkout_user_details_initiated',
    CHECKOUT_USER_DETAILS_COMPLETED = 'checkout_user_details_completed',
    CHECKOUT_USER_OPT_OUT_NEWSLETTER = 'checkout_user_opt_out_newsletter',
    CHECKOUT_ADD_ADDON = 'checkout_add_addon',
    CHECKOUT_REMOVE_ADDON = 'checkout_remove_addon',
    CHECKOUT_ADD_BAGGAGE = 'checkout_add_baggage',
    CHECKOUT_REMOVE_BAGGAGE = 'checkout_remove_baggage',
    CHECKOUT_ADD_SEATING = 'checkout_add_seating',
    CHECKOUT_REMOVE_SEATING = 'checkout_remove_seating',
    CHECKOUT_REMOVE_PRODUCT = 'checkout_remove_product',
    CHECKOUT_SHOW_HOTEL_INFO = 'checkout_show_hotel_info',
    CHECKOUT_SHOW_ROOM_INFO = 'checkout_show_room_info',
    CHECKOUT_TICKET_POLICY_OPEN = 'checkout_ticket_policy_open',
    CHECKOUT_MORE_INFORMATION_OPEN = 'checkout_more_information_open',
    CHECKOUT_PRICE_DETAILS_OPEN = 'checkout_price_details_open',
    CHECKOUT_TRANSFER_BANNER = 'checkout_transfer_banner',
    CHECKOUT_TRANSFER_BANNER_OPEN = 'checkout_transfer_banner_open',
    CHECKOUT_TRANSFER_ADDED = 'checkout_transfer_added',
    CHECKOUT_TRANSFER_INTERACTION = 'checkout_transfer_interaction',
    CHECKOUT_TRANSFER_AVAILABLE_TRIPS = 'checkout_transfer_available_trips',
    CHECKOUT_TRANSFER_AVAILABLE_OPTIONS = 'checkout_transfer_available_options',
    CHECKOUT_CANCELLATION_PANEL_OPEN = 'checkout_cancellation_panel_open',
    CHECKOUT_CANCELLATION_TERMS_OPEN = 'checkout_cancellation_terms_open',
    CHECKOUT_PRICE_BREAKDOWN_BADGE_OPEN = 'checkout_price_breakdown_badge_open',
    CHECKOUT_PRICE_BREAKDOWN_DETAILS_OPEN = 'checkout_price_breakdown_details_open',
    CHECKOUT_PRICE_BREAKDOWN_FOOTER_OPEN = 'checkout_price_breakdown_footer_open',
    CHECKOUT_IMPORTANT_NOTES_OPEN = 'checkout_important_notes_open',
    CHECKOUT_EDIT_SECTION = 'checkout_edit_section',
    CHECKOUT_OPEN_SECTION = 'checkout_open_section',
    CHECKOUT_DUPLICATE_PAX_WARNING_OPEN = 'checkout_duplicate_pax_warning_open',
    CHECKOUT_BAGGAGE_WARNING_OPEN = 'checkout_baggage_warning_open', // position: global/selection
    CHECKOUT_BAGGAGE_WARNING_INTERACTION = 'checkout_baggage_warning_interaction', // position: global/selection, user_action: YES/NO
    CHECKOUT_SERVICE_PACKAGE_WARNING_OPEN = 'checkout_service_package_warning_open',
    CHECKOUT_SERVICE_PACKAGE_WARNING_INTERACTION = 'checkout_service_package_warning_interaction',
    CHECKOUT_COMPLETE_SECTION = 'checkout_complete_section',
    CHECKOUT_INVALID_INPUT = 'checkout_invalid_input',
    CHECKOUT_OPEN_SECTION_DETAILS = 'checkout_open_section_details',
    CHECKOUT_OPEN_SECTION_IMAGE = 'checkout_open_section_image',
    CHECKOUT_OPEN_SECTION_OVERVIEW_DETAILS = 'checkout_open_section_overview_details',
    CHECKOUT_OPEN_SECTION_JOURNEY_DETAILS = 'checkout_open_section_journey_details',
    CHECKOUT_PRICE_GUARANTEE_OPEN = 'checkout_price_guarantee_open',
    CHECKOUT_CHANGE_TRAVELLER = 'checkout_change_traveller',
    CHECKOUT_CHANGE_TRAVELLER_OPEN = 'checkout_change_traveller_open',
    CHECKOUT_SUBMIT_INVALID_STATE = 'checkout_submit_invalid_state',
    CHECKOUT_TRIP_SUMMARY = 'checkout_trip_summary',
    CHECKOUT_TRIP_SUMMARY_EXPAND = 'checkout_trip_summary_expand',
    CHECKOUT_DISCOUNT_CODE_OPEN = 'checkout_discount_code_open',
    CHECKOUT_DISCOUNT_CODE_APPLIED = 'checkout_discount_code_applied',
    CHECKOUT_DISCOUNT_CODE_ERROR = 'checkout_discount_code_error',
    CHECKOUT_COPY_FEATURE_CLICK = 'checkout_copy_feature_click',
    CHECKOUT_COPY_FEATURE_INVALID_FORM = 'checkout_copy_feature_invalid_form',
    CHECKOUT_COPY_FEATURE_APPLIED = 'checkout_copy_feature_applied',
    CHECKOUT_SEMBONUS_AVAILABLE = 'checkout_sembonus_available',
    CHECKOUT_SEMBONUS_APPLIED = 'checkout_sembonus_applied',
    CHECKOUT_SEMBONUS_VIEW = 'checkout_sembonus_view',
    CHECKOUT_SEMBONUS_INTERACTION = 'checkout_sembonus_interaction',
    CHECKOUT_APPLIED_DISCOUNT_INTERACTION = 'checkout_applied_discount_interaction',
    CHECKOUT_SERVICE_PACKAGE_INTERACTION = 'checkout_service_package_interaction',
    CHECKOUT_BRANDED_FARE_SELECTED = 'checkout_branded_fare_selected',
    PAYMENT_PAGE_INITIATED = 'payment_page_initiated',
    PAYMENT_TYPE_SELECT = 'payment_type_select',
    PAYMENT_METHOD_SELECT = 'payment_method_select',
    PAYMENT_METHOD_COMPLETED = 'payment_method_completed',
    PAYMENT_CANCELLATION_TERMS_CLICK = 'payment_cancellation_terms_click',
    PAYMENT_GIFT_CARD_REQUIRES_CVC = 'payment_gift_card_requires_cvc',
    PAYMENT_FAILED_ERROR = 'payment_failed_error',
    PAYMENT_PAGE_MESSAGE = 'payment_page_message',
    PAYMENT_BOOKING_REDIRECT = 'payment_booking_redirect',
    PAYMENT_LEABANK_FORM_OPEN = 'leabank_form_open',
    PAYMENT_LEABANK_SUBMIT_APPLICATION = 'leabank_submit_application',
    PAYMENT_BOOK_NOW_PAY_LATER_AVAILABLE = 'payment_book_now_pay_later_available',
    PAYMENT_BOOK_NOW_PAY_LATER_INTERACTION = 'payment_book_now_pay_later_interaction',
    PRE_CHECKOUT_PAGE_INITIATED = 'pre_checkout_page_initiated',
    PRE_CHECKOUT_PAGE_COMPLETED = 'pre_checkout_page_completed',
    PRE_CHECKOUT_PAGE_REDIRECTED = 'pre_checkout_page_redirected',
    PRE_CHECKOUT_BRANDED_FARE_AVAILABLE = 'pre_checkout_branded_fare_available',
    PRE_CHECKOUT_BRANDED_FARE_OPTION_AVAILABLE = 'pre_checkout_branded_fare_option_available',
    POST_CHECKOUT_PAGE_INITIATED = 'post_checkout_page_initiated',
    POST_CHECKOUT_PAGE_COMPLETED = 'post_checkout_page_completed',
    SKIP_POST_CHECKOUT_PAGE = 'skip_post_checkout_page',
    META_FLIGHT_PAGE_INITIATED = 'meta_flight_page_initiated',
    GENERAL_ERROR = 'general_error',
    CUSTOM_ERROR = 'custom_error',
    PERFORMANCE_API = 'performance_api',
    TRANSLATION_MISSING_KEY = 'translation_missing_key',
    SEATING_AVAILABILITY_STATUS = 'seating_availability_status',
    AMELIA_AVAILABLE = 'amelia_available',
    AMELIA_INTERACTION = 'amelia_interaction',
    AMELIA_FEEDBACK_MESSAGE = 'amelia_feedback_message',
}

interface Value {
    [key: string]: any;
}

interface MetaData {
    [key: string]: any;
}

export interface StatsigTracking {
    hostname: string;
    href: string;
    language: string;
    isDesktop: boolean;
}

export interface StatsigTrackingExtra {
    referrer?: string;
    isBooking?: boolean;
    page?: string;
    prevPage?: string;
    shoppingCartKey?: string;
    businessArea?: string;
    mainSalesChannel?: string;
    bookingSalesChannels?: string[];
    affiliateId?: string | null;
    affiliateGroupName?: string | null;
}

interface StatsigDefault {
    value?: Value;
    metadata?: MetaData;
}

export enum BaggageWarningPosition {
    Selection = 'selection',
    Global = 'global',
}

export enum SembonusView {
    Unauthorized = 'Unauthorized',
    Join = 'Join',
    RedeemBonusNights = 'RedeemBonusNights',
    RedeemNoneAvailable = 'RedeemNoneAvailable',
    NotEligible = 'NotEligible',
}

export enum BaggageWarningInteraction {
    Yes = 'yes',
    No = 'no',
    Skip = 'skip',
    ShowAlternatives = 'show_alternatives',
}

interface CheckoutPageInitiatedEvent extends StatsigDefault {
    eventName: StatsigEvent.CHECKOUT_PAGE_INITIATED;
}

interface CheckoutRyanairInteractionEvent extends StatsigDefault {
    eventName: StatsigEvent.CHECKOUT_RYANAIR_INTERACTION;
}

interface CheckoutCartSessionStoreEvent extends StatsigDefault {
    eventName: StatsigEvent.CHECKOUT_CART_SESSION_STORE;
}

interface CheckoutCartSessionUpdateEvent extends StatsigDefault {
    eventName: StatsigEvent.CHECKOUT_CART_SESSION_UPDATE;
}

interface CheckoutUserDetailsInitiatedEvent extends StatsigDefault {
    eventName: StatsigEvent.CHECKOUT_USER_DETAILS_INITIATED;
}

interface CheckoutUserDetailsCompletedEvent extends StatsigDefault {
    eventName: StatsigEvent.CHECKOUT_USER_DETAILS_COMPLETED;
}

interface CheckoutUserOptOutNewsletterEvent extends StatsigDefault {
    eventName: StatsigEvent.CHECKOUT_USER_OPT_OUT_NEWSLETTER;
}

interface CheckoutAddAddonEvent extends StatsigDefault {
    eventName: StatsigEvent.CHECKOUT_ADD_ADDON;
}

interface CheckoutRemoveAddonEvent extends StatsigDefault {
    eventName: StatsigEvent.CHECKOUT_REMOVE_ADDON;
}

interface CheckoutAddBaggageEvent extends StatsigDefault {
    eventName: StatsigEvent.CHECKOUT_ADD_BAGGAGE;
}

interface CheckoutRemoveBaggageEvent extends StatsigDefault {
    eventName: StatsigEvent.CHECKOUT_REMOVE_BAGGAGE;
}

interface CheckoutAddSeatingEvent extends StatsigDefault {
    eventName: StatsigEvent.CHECKOUT_ADD_SEATING;
}

interface CheckoutRemoveSeatingEvent extends StatsigDefault {
    eventName: StatsigEvent.CHECKOUT_REMOVE_SEATING;
}

interface CheckoutRemoveProductEvent extends StatsigDefault {
    eventName: StatsigEvent.CHECKOUT_REMOVE_PRODUCT;
}

interface CheckoutShowHotelInfo extends StatsigDefault {
    eventName: StatsigEvent.CHECKOUT_SHOW_HOTEL_INFO;
}

interface CheckoutShowRoomInfo extends StatsigDefault {
    eventName: StatsigEvent.CHECKOUT_SHOW_ROOM_INFO;
}

interface CheckoutCancellationPanelOpen extends StatsigDefault {
    eventName: StatsigEvent.CHECKOUT_CANCELLATION_PANEL_OPEN;
}
interface CheckoutCancellationTermsOpen extends StatsigDefault {
    eventName: StatsigEvent.CHECKOUT_CANCELLATION_TERMS_OPEN;
}

interface CheckoutPriceBreakdownBadgeOpen extends StatsigDefault {
    eventName: StatsigEvent.CHECKOUT_PRICE_BREAKDOWN_BADGE_OPEN;
}

interface CheckoutPriceBreakdownDetailsOpen extends StatsigDefault {
    eventName: StatsigEvent.CHECKOUT_PRICE_BREAKDOWN_DETAILS_OPEN;
}

interface CheckoutPriceBreakdownFooterOpen extends StatsigDefault {
    eventName: StatsigEvent.CHECKOUT_PRICE_BREAKDOWN_FOOTER_OPEN;
}

interface CheckoutPriceGuaranteeOpen extends StatsigDefault {
    eventName: StatsigEvent.CHECKOUT_PRICE_GUARANTEE_OPEN;
}

interface CheckoutChangeTraveller extends StatsigDefault {
    eventName: StatsigEvent.CHECKOUT_CHANGE_TRAVELLER;
}

interface CheckoutChangeTravellerOpen extends StatsigDefault {
    eventName: StatsigEvent.CHECKOUT_CHANGE_TRAVELLER_OPEN;
}

interface CheckoutSubmitInvalidState extends StatsigDefault {
    eventName: StatsigEvent.CHECKOUT_SUBMIT_INVALID_STATE;
}

interface CheckoutImportantNotesOpen extends StatsigDefault {
    eventName: StatsigEvent.CHECKOUT_IMPORTANT_NOTES_OPEN;
}

interface CheckoutEditSection extends StatsigDefault {
    eventName: StatsigEvent.CHECKOUT_EDIT_SECTION;
}

interface CheckoutOpenSection extends StatsigDefault {
    eventName: StatsigEvent.CHECKOUT_OPEN_SECTION;
}

interface CheckoutCompleteSection extends StatsigDefault {
    eventName: StatsigEvent.CHECKOUT_COMPLETE_SECTION;
}

interface CheckoutInvalidInput extends StatsigDefault {
    eventName: StatsigEvent.CHECKOUT_INVALID_INPUT;
}

interface CheckoutOpenSectionDetails extends StatsigDefault {
    eventName: StatsigEvent.CHECKOUT_OPEN_SECTION_DETAILS;
}

interface CheckoutOpenSectionImage extends StatsigDefault {
    eventName: StatsigEvent.CHECKOUT_OPEN_SECTION_IMAGE;
}

interface CheckoutOpenSectionOverviewDetails extends StatsigDefault {
    eventName: StatsigEvent.CHECKOUT_OPEN_SECTION_OVERVIEW_DETAILS;
}

interface CheckoutOpenSectionJourneyDetails extends StatsigDefault {
    eventName: StatsigEvent.CHECKOUT_OPEN_SECTION_JOURNEY_DETAILS;
}

interface CheckoutTripSummary extends StatsigDefault {
    eventName: StatsigEvent.CHECKOUT_TRIP_SUMMARY;
}

interface CheckoutTripSummaryExpand extends StatsigDefault {
    eventName: StatsigEvent.CHECKOUT_TRIP_SUMMARY_EXPAND;
}

interface CheckoutDiscountCodeOpen extends StatsigDefault {
    eventName: StatsigEvent.CHECKOUT_DISCOUNT_CODE_OPEN;
}

interface CheckoutDiscountCodeApplied extends StatsigDefault {
    eventName: StatsigEvent.CHECKOUT_DISCOUNT_CODE_APPLIED;
}

interface CheckoutDiscountCodeError extends StatsigDefault {
    eventName: StatsigEvent.CHECKOUT_DISCOUNT_CODE_ERROR;
}

interface CheckoutCopyFeatureClick extends StatsigDefault {
    eventName: StatsigEvent.CHECKOUT_COPY_FEATURE_CLICK;
}

interface CheckoutCopyFeatureInvalidForm extends StatsigDefault {
    eventName: StatsigEvent.CHECKOUT_COPY_FEATURE_INVALID_FORM;
}

interface CheckoutCopyFeatureApplied extends StatsigDefault {
    eventName: StatsigEvent.CHECKOUT_COPY_FEATURE_APPLIED;
}

interface CheckoutSembonusAvailable extends StatsigDefault {
    eventName: StatsigEvent.CHECKOUT_SEMBONUS_AVAILABLE;
}

interface CheckoutSembonusApplied extends StatsigDefault {
    eventName: StatsigEvent.CHECKOUT_SEMBONUS_APPLIED;
}

interface CheckoutSembonusView extends StatsigDefault {
    eventName: StatsigEvent.CHECKOUT_SEMBONUS_VIEW;
}

interface CheckoutSembonusInteraction extends StatsigDefault {
    eventName: StatsigEvent.CHECKOUT_SEMBONUS_INTERACTION;
}

interface CheckoutMoreInformationOpen extends StatsigDefault {
    eventName: StatsigEvent.CHECKOUT_MORE_INFORMATION_OPEN;
}

interface CheckoutPriceDetailsOpen extends StatsigDefault {
    eventName: StatsigEvent.CHECKOUT_PRICE_DETAILS_OPEN;
}

interface CheckoutTransferBanner extends StatsigDefault {
    eventName: StatsigEvent.CHECKOUT_TRANSFER_BANNER;
}

interface CheckoutTransferAdded extends StatsigDefault {
    eventName: StatsigEvent.CHECKOUT_TRANSFER_ADDED;
}

interface CheckoutTransferBannerOpen extends StatsigDefault {
    eventName: StatsigEvent.CHECKOUT_TRANSFER_BANNER_OPEN;
}

interface CheckoutTransferInteraction extends StatsigDefault {
    eventName: StatsigEvent.CHECKOUT_TRANSFER_INTERACTION;
}

interface CheckoutTransferAvailableTrips extends StatsigDefault {
    eventName: StatsigEvent.CHECKOUT_TRANSFER_AVAILABLE_TRIPS;
}

interface CheckoutTransferAvailableOptions extends StatsigDefault {
    eventName: StatsigEvent.CHECKOUT_TRANSFER_AVAILABLE_OPTIONS;
}

interface CheckoutTicketPolicyOpen extends StatsigDefault {
    eventName: StatsigEvent.CHECKOUT_TICKET_POLICY_OPEN;
}

interface CheckoutAppliedDiscountInteraction extends StatsigDefault {
    eventName: StatsigEvent.CHECKOUT_APPLIED_DISCOUNT_INTERACTION;
}

interface CheckoutServicePackageInteraction extends StatsigDefault {
    eventName: StatsigEvent.CHECKOUT_SERVICE_PACKAGE_INTERACTION;
}

interface CheckoutBrandedFareSelected extends StatsigDefault {
    eventName: StatsigEvent.CHECKOUT_BRANDED_FARE_SELECTED;
}

interface PaymentPageInitiatedEvent extends StatsigDefault {
    eventName: StatsigEvent.PAYMENT_PAGE_INITIATED;
}

interface PaymentMethodCompletedEvent extends StatsigDefault {
    eventName: StatsigEvent.PAYMENT_METHOD_COMPLETED;
}

interface PaymentFailedError extends StatsigDefault {
    eventName: StatsigEvent.PAYMENT_FAILED_ERROR;
}

interface PaymentTypeSelectEvent extends StatsigDefault {
    eventName: StatsigEvent.PAYMENT_TYPE_SELECT;
}

interface PaymentMethodSelectEvent extends StatsigDefault {
    eventName: StatsigEvent.PAYMENT_METHOD_SELECT;
}

interface PaymentCancellationTermsClick extends StatsigDefault {
    eventName: StatsigEvent.PAYMENT_CANCELLATION_TERMS_CLICK;
}

interface PaymentGiftCardRequiresCvcEvent extends StatsigDefault {
    eventName: StatsigEvent.PAYMENT_GIFT_CARD_REQUIRES_CVC;
}

interface PaymentPageMessage extends StatsigDefault {
    eventName: StatsigEvent.PAYMENT_PAGE_MESSAGE;
}

interface PaymentBookingRedirect extends StatsigDefault {
    eventName: StatsigEvent.PAYMENT_BOOKING_REDIRECT;
}

interface PaymentLeabankFormOpen extends StatsigDefault {
    eventName: StatsigEvent.PAYMENT_LEABANK_FORM_OPEN;
}

interface PaymentLeabankSubmitApplication extends StatsigDefault {
    eventName: StatsigEvent.PAYMENT_LEABANK_SUBMIT_APPLICATION;
}

interface PaymentBookNowPayLaterAvailable extends StatsigDefault {
    eventName: StatsigEvent.PAYMENT_BOOK_NOW_PAY_LATER_AVAILABLE;
}

interface PaymentBookNowPayLaterInteraction extends StatsigDefault {
    eventName: StatsigEvent.PAYMENT_BOOK_NOW_PAY_LATER_INTERACTION;
}

interface BookingHotelWidgetAddon extends StatsigDefault {
    eventName: StatsigEvent.BOOKING_HOTEL_WIDGET_ADDON;
}

interface BookingTripWidgetAddon extends StatsigDefault {
    eventName: StatsigEvent.BOOKING_TRIP_WIDGET_ADDON;
}

interface BookingRentalCarWidgetAddon extends StatsigDefault {
    eventName: StatsigEvent.BOOKING_RENTALCAR_WIDGET_ADDON;
}

interface BookingHotelWidgetEmptyResult extends StatsigDefault {
    eventName: StatsigEvent.BOOKING_HOTEL_WIDGET_EMPTY_RESULT;
}

interface BookingTripWidgetAvailable extends StatsigDefault {
    eventName: StatsigEvent.BOOKING_TRIP_WIDGET_AVAILABLE;
}

interface BookingAccommodationAddon extends StatsigDefault {
    eventName: StatsigEvent.BOOKING_ACCOMMODATION_ADDON;
}

interface BookingBaggageAddon extends StatsigDefault {
    eventName: StatsigEvent.BOOKING_BAGGAGE_ADDON;
}

interface BookingRentalCarAddon extends StatsigDefault {
    eventName: StatsigEvent.BOOKING_RENTALCAR_ADDON;
}

interface BookingTransferAddon extends StatsigDefault {
    eventName: StatsigEvent.BOOKING_TRANSFER_ADDON;
}

interface BookingServicePackageAddon extends StatsigDefault {
    eventName: StatsigEvent.BOOKING_SERVICEPACKAGE_ADDON;
}

interface BookingTravelInsuranceAddon extends StatsigDefault {
    eventName: StatsigEvent.BOOKING_TRAVELINSURANCE_ADDON;
}

interface BookingSeatingAddon extends StatsigDefault {
    eventName: StatsigEvent.BOOKING_SEATING_ADDON;
}

interface BookingFerryAddon extends StatsigDefault {
    eventName: StatsigEvent.BOOKING_FERRY_ADDON;
}

interface BookingFerryExtraAddon extends StatsigDefault {
    eventName: StatsigEvent.BOOKING_FERRY_EXTRA_ADDON;
}

interface BookingAddonOpen extends StatsigDefault {
    eventName: StatsigEvent.BOOKING_ADDON_OPEN;
}

interface BookingSpotlights extends StatsigDefault {
    eventName: StatsigEvent.BOOKING_SPOTLIGHTS;
}

interface BookingSpotlightsRearranged extends StatsigDefault {
    eventName: StatsigEvent.BOOKING_SPOTLIGHTS_REARRANGED;
}

interface BookingUpsellInteraction extends StatsigDefault {
    eventName: StatsigEvent.BOOKING_UPSELL_INTERACTION;
}

interface BookingHotelWidgetInteraction extends StatsigDefault {
    eventName: StatsigEvent.BOOKING_HOTEL_WIDGET_INTERACTION;
}

interface BookingHotelWidgetAvailable extends StatsigDefault {
    eventName: StatsigEvent.BOOKING_HOTEL_WIDGET_AVAILABLE;
}

interface BookingPageInitiated extends StatsigDefault {
    eventName: StatsigEvent.BOOKING_PAGE_INITIATED;
}

interface BookingPageInteraction extends StatsigDefault {
    eventName: StatsigEvent.BOOKING_PAGE_INTERACTION;
}

interface BookingRyanairVerification extends StatsigDefault {
    eventName: StatsigEvent.BOOKING_RYANAIR_VERIFICATION;
}

interface BookingRyanairInteraction extends StatsigDefault {
    eventName: StatsigEvent.BOOKING_RYANAIR_INTERACTION;
}

interface BookingRyanairBookingExpired extends StatsigDefault {
    eventName: StatsigEvent.BOOKING_RYANAIR_BOOKING_EXPIRED;
}

interface BookingCancellationTermsClick extends StatsigDefault {
    eventName: StatsigEvent.BOOKING_CANCELLATION_TERMS_CLICK;
}

interface BookingTransferConditionsClick extends StatsigDefault {
    eventName: StatsigEvent.BOOKING_TRANSFER_CONDITIONS_CLICK;
}

interface BookingTransferVoucherClick extends StatsigDefault {
    eventName: StatsigEvent.BOOKING_TRANSFER_VOUCHER_CLICK;
}

interface BookingCancelClick extends StatsigDefault {
    eventName: StatsigEvent.BOOKING_CANCEL_CLICK;
}

interface BookingPayClick extends StatsigDefault {
    eventName: StatsigEvent.BOOKING_PAY_CLICK;
}

interface BookingPaymentModal extends StatsigDefault {
    eventName: StatsigEvent.BOOKING_PAYMENT_MODAL;
}

interface BookingPaymentModalInteraction extends StatsigDefault {
    eventName: StatsigEvent.BOOKING_PAYMENT_MODAL_INTERACTION;
}

interface BookingPaymentRedirect extends StatsigDefault {
    eventName: StatsigEvent.BOOKING_PAYMENT_REDIRECT;
}

interface BookingBrandedFareSelected extends StatsigDefault {
    eventName: StatsigEvent.BOOKING_BRANDED_FARE_SELECTED;
}

interface BookingConfirmationClick extends StatsigDefault {
    eventName: StatsigEvent.BOOKING_CONFIRMATION_CLICK;
}

interface BookingVoucherClick extends StatsigDefault {
    eventName: StatsigEvent.BOOKING_VOUCHER_CLICK;
}

interface BookingFooterNewsletterClick extends StatsigDefault {
    eventName: StatsigEvent.BOOKING_FOOTER_NEWSLETTER_CLICK;
}

interface BookingFooterFaqClick extends StatsigDefault {
    eventName: StatsigEvent.BOOKING_FOOTER_FAQ_CLICK;
}

interface BookingUpsellAvailable extends StatsigDefault {
    eventName: StatsigEvent.BOOKING_UPSELL_AVAILABLE;
}

interface BookingServicePackageAvailable extends StatsigDefault {
    eventName: StatsigEvent.BOOKING_SERVICE_PACKAGE_AVAILABLE;
}

interface BookingServicePackageInteraction extends StatsigDefault {
    eventName: StatsigEvent.BOOKING_SERVICE_PACKAGE_INTERACTION;
}

interface BookingServicePackageOpen extends StatsigDefault {
    eventName: StatsigEvent.BOOKING_SERVICE_PACKAGE_OPEN;
}

interface BookingServicePackageClose extends StatsigDefault {
    eventName: StatsigEvent.BOOKING_SERVICE_PACKAGE_CLOSE;
}

interface BookingOpenSectionJourneyDetails extends StatsigDefault {
    eventName: StatsigEvent.BOOKING_OPEN_SECTION_JOURNEY_DETAILS;
}

interface BookingOpenSectionPassengersDetails extends StatsigDefault {
    eventName: StatsigEvent.BOOKING_OPEN_SECTION_PASSENGERS_DETAILS;
}

interface BookingOpenSupplierNotes extends StatsigDefault {
    eventName: StatsigEvent.BOOKING_OPEN_SUPPLIER_NOTES;
}

interface BookingServicePackageRequestOpen extends StatsigDefault {
    eventName: StatsigEvent.BOOKING_SERVICE_PACKAGE_REQUEST_OPEN;
}

interface BookingServicePackageRequestSent extends StatsigDefault {
    eventName: StatsigEvent.BOOKING_SERVICE_PACKAGE_REQUEST_SENT;
}

interface BookingCustomerServiceMessagesOpen extends StatsigDefault {
    eventName: StatsigEvent.BOOKING_CUSTOMER_SERVICE_MESSAGES_OPEN;
}

interface BookingPackageRulesPrompted extends StatsigDefault {
    eventName: StatsigEvent.BOOKING_PACKAGE_RULES_PROMPTED;
}

interface BookingPackageRulesContinued extends StatsigDefault {
    eventName: StatsigEvent.BOOKING_PACKAGE_RULES_CONTINUED;
}

interface BookingImportantInformationOpen extends StatsigDefault {
    eventName: StatsigEvent.BOOKING_IMPORTANT_INFORMATION_OPEN;
}

interface BookingCouponVisible extends StatsigDefault {
    eventName: StatsigEvent.BOOKING_COUPON_VISIBLE;
}

interface BookingCouponOpen extends StatsigDefault {
    eventName: StatsigEvent.BOOKING_COUPON_OPEN;
}

interface BookingCouponClose extends StatsigDefault {
    eventName: StatsigEvent.BOOKING_COUPON_CLOSE;
}

interface BookingCouponCodeCopied extends StatsigDefault {
    eventName: StatsigEvent.BOOKING_COUPON_CODE_COPIED;
}

interface BookingAddRemoveAddon extends StatsigDefault {
    eventName: StatsigEvent.BOOKING_ADD_ADDON | StatsigEvent.BOOKING_REMOVE_ADDON;
}

interface BookingsPageInitiated extends StatsigDefault {
    eventName: StatsigEvent.BOOKINGS_PAGE_INITIATED;
}

interface BookingsPageInteraction extends StatsigDefault {
    eventName: StatsigEvent.BOOKINGS_PAGE_INTERACTION;
}

interface MetaFlightPageInitiated extends StatsigDefault {
    eventName: StatsigEvent.META_FLIGHT_PAGE_INITIATED;
}

interface PreCheckoutPageInitiated extends StatsigDefault {
    eventName: StatsigEvent.PRE_CHECKOUT_PAGE_INITIATED;
}
interface PreCheckoutPageCompleted extends StatsigDefault {
    eventName: StatsigEvent.PRE_CHECKOUT_PAGE_COMPLETED;
}

interface PreCheckoutPageRedirected extends StatsigDefault {
    eventName: StatsigEvent.PRE_CHECKOUT_PAGE_REDIRECTED;
}

interface PreCheckoutBrandedFareAvailable extends StatsigDefault {
    eventName: StatsigEvent.PRE_CHECKOUT_BRANDED_FARE_AVAILABLE;
}

interface PreCheckoutBrandedFareOptionAvailable extends StatsigDefault {
    eventName: StatsigEvent.PRE_CHECKOUT_BRANDED_FARE_OPTION_AVAILABLE;
}

interface PostCheckoutPageInitiated extends StatsigDefault {
    eventName: StatsigEvent.POST_CHECKOUT_PAGE_INITIATED;
}
interface PostCheckoutPageCompleted extends StatsigDefault {
    eventName: StatsigEvent.POST_CHECKOUT_PAGE_COMPLETED;
}

interface SkipPostCheckoutPage extends StatsigDefault {
    eventName: StatsigEvent.SKIP_POST_CHECKOUT_PAGE;
}

interface GeneralError extends StatsigDefault {
    eventName: StatsigEvent.GENERAL_ERROR;
}

interface CustomError extends StatsigDefault {
    eventName: StatsigEvent.CUSTOM_ERROR;
}

interface PerformanceAPI extends StatsigDefault {
    eventName: StatsigEvent.PERFORMANCE_API;
}

interface TranslationMissingKey extends StatsigDefault {
    eventName: StatsigEvent.TRANSLATION_MISSING_KEY;
}

interface SeatingAvailabilityStatus extends StatsigDefault {
    eventName: StatsigEvent.SEATING_AVAILABILITY_STATUS;
}

interface CheckoutBaggageWarningOpen extends StatsigDefault {
    eventName: StatsigEvent.CHECKOUT_BAGGAGE_WARNING_OPEN;
}

interface CheckoutBaggageWarningInteraction extends StatsigDefault {
    eventName: StatsigEvent.CHECKOUT_BAGGAGE_WARNING_INTERACTION;
}

interface CheckoutServicePackageWarningOpen extends StatsigDefault {
    eventName: StatsigEvent.CHECKOUT_SERVICE_PACKAGE_WARNING_OPEN;
}

interface CheckoutServicePackageWarningInteraction extends StatsigDefault {
    eventName: StatsigEvent.CHECKOUT_SERVICE_PACKAGE_WARNING_INTERACTION;
}

interface CheckoutDuplicatePaxWarningOpen extends StatsigDefault {
    eventName: StatsigEvent.CHECKOUT_DUPLICATE_PAX_WARNING_OPEN;
}

interface AmeliaAvailable extends StatsigDefault {
    eventName: StatsigEvent.AMELIA_AVAILABLE;
}

interface AmeliaInteraction extends StatsigDefault {
    eventName: StatsigEvent.AMELIA_INTERACTION;
}

interface AmeliaFeedbackMessage extends StatsigDefault {
    eventName: StatsigEvent.AMELIA_FEEDBACK_MESSAGE;
}
